import gql from 'graphql-tag';

export const ETF_DISTRIBUTION = gql`
    query Distribution($ticker: String!) {
        exchangeTradedFund(ticker: $ticker) {
            distribution {
                distributionFrequency
                distributions {
                    recordDate
                    payDate
                    exDate
                    income
                    shortTermCapitalGains
                    longTermCapitalGains
                    returnOfCapital
                    totalDistribution
                }
            }
        }
    }
`;
